import React from 'react';
import { Link } from 'react-router-dom';
import { overviewLinks, quickLinks } from '../data/footerPages';
import { socialLinks } from '../data/socialLinks';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="border-b border-white/10 py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="font-display text-2xl tracking-[0.2em] uppercase">Metameni</span>
            <p className="mt-4 text-gray-400 text-sm leading-relaxed font-light">
              Science-backed skincare for the modern Indian. No frills. No fillers. Just results.
            </p>
            <p className="mt-5 text-xs tracking-[0.2em] uppercase text-gray-400">Contact Us</p>
            <p className="mt-2 text-sm text-gray-400 font-light">
              For any suggestions, feedback, or concerns, fill out{' '}
              <Link to="/contact" className="underline hover:text-gray-300 transition-colors">
                our form
              </Link>{' '}
              or email us at
            </p>
            <a
              href="mailto:hello@metameni.com"
              className="mt-1 inline-block text-sm text-white hover:text-gray-300 transition-colors"
            >
              hello@metameni.com
            </a>
            <div className="mt-6 flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Visit Metameni on ${social.name}`}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/5 transition-colors hover:border-white hover:bg-white/10"
                >
                  <i className={`${social.icon} text-white text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-gray-400 mb-4">Overview</p>
            <ul className="space-y-2.5">
              {overviewLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-gray-400 mb-4">Quick Links</p>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-gray-400 mb-4">Also Available On</p>
            <ul className="space-y-2.5">
              {[
                { name: 'Amazon', url: 'https://www.amazon.in/dp/B0H4B5FD4C?th=1' },
                { name: 'Flipkart', url: null },
                { name: 'Meesho', url: null },
              ].map((item) => (
                <li key={item.name}>
                  {item.url ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-gray-400 hover:text-white transition-colors"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <span className="text-sm text-gray-400">{item.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-gray-600">© 2026 Metameni Skincare. All Rights Reserved.</p>
        <p className="text-xs text-gray-600">
          Dermatologically Tested · Cruelty Free · Country of Origin :
          <span className="text-white"> India</span>
        </p>
      </div>
    </footer>
  );
}
